import React from 'react';
import './../RedemptionForm.css';

const CheckoutForm = ({ address, loading, error, onChange, onSubmit, countryData }) => (
  <form onSubmit={onSubmit} className="form-container">
    <h3>Please enter the following information</h3>

    <label className="form-label">
      <input name="company" value={address.company} onChange={onChange} type="text" hidden />

      <label>First Name</label>
      <input
        name="firstname"
        className="form-input"
        placeholder="First Name"
        value={address.firstname}
        onChange={onChange}
        type="text"
        required
      />

      <label>Last Name</label>
      <input
        name="lastname"
        className="form-input"
        placeholder="Last Name"
        value={address.lastname}
        onChange={onChange}
        type="text"
        required
      />

      <label>Email</label>
      <input
        name="email"
        className="form-input"
        placeholder="Email"
        value={address.email}
        onChange={onChange}
        type="email"
        required
      />

      <label>Phone</label>
      <input
        name="telephone"
        className="form-input"
        placeholder="Phone"
        value={address.telephone}
        onChange={onChange}
        type="text"
        required
      />

      <label>Country</label>
      <select
        name="country_id"
        className="form-input"
        value={address.country_id}
        onChange={onChange}
        required
      >
        <option value="" disabled>
          Select a country
        </option>
        <option value="US" id="231">
          United States
        </option>
        <option value="CA" id="232">
          Canada
        </option>
      </select>

      <label>Address 1</label>
      <input
        name="street1"
        className="form-input"
        placeholder="Address 1"
        value={address.street1}
        onChange={onChange}
        type="text"
        required
      />

      <label>Address 2</label>
      <input
        name="street2"
        className="form-input"
        placeholder="Address 2"
        value={address.street2}
        onChange={onChange}
        type="text"
      />

      <label>City</label>
      <input
        name="city"
        className="form-input"
        placeholder="City"
        value={address.city}
        onChange={onChange}
        type="text"
        required
      />

      <label>State</label>
      <select
        name="region_code"
        className="form-input"
        value={address.region_code}
        onChange={onChange}
      >
        <option value="">Select a state</option>
        {countryData?.available_regions?.map((region) => (
          <option key={region.id} value={region.code}>
            {region.name}
          </option>
        ))}
      </select>

      <label>Zip Code</label>
      <input
        name="postcode"
        className="form-input"
        placeholder="Zip Code"
        value={address.postcode}
        onChange={onChange}
        type="text"
        required
      />

      <input
        name="shipping_method_code"
        value={address.shipping_method_code}
        onChange={onChange}
        type="text"
        hidden
      />
      <input
        name="shipping_carrier_code"
        value={address.shipping_carrier_code}
        onChange={onChange}
        type="text"
        hidden
      />
    </label>

    <button type="submit" className="form-button" disabled={loading}>
      {loading ? 'submitting...' : 'Submit'}
    </button>
    {error && <p className="form-error">{error}</p>}
  </form>
);

export default CheckoutForm;
